import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Observable as __Observable } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const MASTER_TOKEN_KEY = 'master-token'; // Original login token for get-programs API
@Injectable({
  providedIn: 'root',
})
export class AuthenticationCheckService {
  authenticationState: boolean = false;

  constructor(private router: Router) {
    this.checkToken();
  }

  checkToken() {
    let token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      this.authenticationState = true;
    }
  }
  /**
   * Get the stored auth token (without Bearer prefix)
   */
  getAuthToken() {
    const token = window.localStorage.getItem(TOKEN_KEY);
    if (!token) return null;
    // Remove any Bearer prefix and trim whitespace/control characters
    return token.replace(/^Bearer\s+/i, '').trim();
  }

  /**
   * Get the original login token (master token, without Bearer prefix)
   * Used for pre-login APIs like get-programs
   */
  getMasterToken() {
    const token = window.localStorage.getItem(MASTER_TOKEN_KEY);
    if (!token) return null;
    // Remove any Bearer prefix and trim whitespace/control characters
    return token.replace(/^Bearer\s+/i, '').trim();
  }

  /**
   * Save the original login token separately
   * This is called after login, before program selection
   * Note: Stores token WITHOUT Bearer prefix - the HTTP interceptor adds it
   */
  async saveMasterToken(token: string) {
    // Remove any existing Bearer prefix and trim whitespace/control characters
    const cleanToken = token.replace(/^Bearer\s+/i, '').trim();
    await localStorage.setItem(MASTER_TOKEN_KEY, cleanToken);
    return true;
  }

  /**
   * Save authentication token
   * Note: Stores token WITHOUT Bearer prefix - the HTTP interceptor adds it
   */
  async saveAuth(token) {
    // Remove any existing Bearer prefix and trim whitespace/control characters
    const cleanToken = token.replace(/^Bearer\s+/i, '').trim();
    await localStorage.setItem(TOKEN_KEY, cleanToken);
    this.authenticationState = true;
    return true;
  }

  logout() {
    localStorage.clear();
    this.authenticationState = false;
    return this.router.navigateByUrl('/signin', { replaceUrl: true });
  }

  isAuthenticated() {
    return this.authenticationState;
  }
}
